"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var createSelector = reselect_1.createSelectorCreator(reselect_1.defaultMemoize, function (a, b) { return JSON.stringify(a) === JSON.stringify(b); });
exports.inputSelectorFactory = function (id) {
    return createSelector(function (state) {
        return Object.keys(state).map(function (feature) { return ({
            key: feature,
            value: state[feature][id],
        }); });
    }, function (features) {
        return features.reduce(function (obj, feature) {
            var _a;
            return (__assign({}, obj, (_a = {}, _a[feature.key] = feature.value, _a)));
        }, {});
    });
};
//# sourceMappingURL=inputSelector.js.map